export default {
  namespaced: true,
  state: {
    loading: false,
    requestsPending: 0,
    loadingText: "",
  },

  getters: {
    loading(state) {
      return state.loading;
    },
    loadingText(state) {
      return state.loadingText;
    },
  },

  mutations: {
    show(state) {
      state.loading = true;
    },
    hide(state) {
      state.loading = false;
    },
    pending(state) {
      if (state.requestsPending === 0) {
        this.commit("loader/show");
      }

      state.requestsPending++;
    },
    pendingWithText(state, payload) {
      if (state.requestsPending === 0) {
        state.loadingText = payload.loadingText;
        this.commit("loader/show");
      }

      state.requestsPending++;
    },
    done(state) {
      if (state.requestsPending >= 1) {
        state.requestsPending--;
      }

      if (state.requestsPending <= 0) {
        state.loadingText = "";
        this.commit("loader/hide");
      }
    },
  },

  actions: {
    show({ commit }) {
      commit("show");
    },
    hide({ commit }) {
      commit("hide");
    },
    pending({ commit }) {
      commit("pending");
    },
    pendingWithText({ commit }, payload) {
      commit("pendingWithText", payload);
    },
    done({ commit }) {
      commit("done");
    },
  },
};
